<!-- PLACEHOLDER: pending Marc — clean functional 3-tier layout, not final design/branding -->
<div class="pro-upsell-modal">
  <div class="modal-header">
    <img src="assets/img/SG-logo-350px.png" alt="Statement Games" class="sg-logo" />
    <button type="button" class="close-btn" (click)="close()">&times;</button>
  </div>

  <div class="modal-body">
    <h2 class="modal-title">Choose Your Plan</h2>

    <p class="modal-description" *ngIf="dailyContestLimit">
      You've reached your <strong>{{ dailyContestLimit }} daily Rookie contests</strong>.
      <em>Upgrade for more contests and prize eligibility.</em>
    </p>

    <!-- Shown for triggers that are not the daily-contest cap (e.g. Create
         Private Contest). Mutually exclusive with the banner above so the
         user is never told they hit a limit they haven't hit. -->
    <p class="modal-description" *ngIf="!dailyContestLimit && contextMessage">
      {{ contextMessage }}
    </p>

    <div class="tier-loading" *ngIf="loadingTiers">Loading plans&hellip;</div>

    <ng-container *ngIf="!loadingTiers && tiers.length > 0">
      <!-- Billing period toggle applies to both paid tiers (Commissioner, Pro) -->
      <div class="billing-toggle">
        <button
          type="button"
          class="toggle-btn"
          [class.active]="selectedPlan === 'monthly'"
          (click)="selectPlan('monthly')"
        >Monthly</button>
        <button
          type="button"
          class="toggle-btn"
          [class.active]="selectedPlan === 'annual'"
          (click)="selectPlan('annual')"
        >Annual</button>
      </div>

      <!-- Rookie, Commissioner, Pro — mandated display order, see conventions.md -->
      <div class="tier-cards-container">
        <div
          class="tier-card"
          *ngFor="let tier of tiers"
          [class.popular]="tier.isMostPopular"
          [class.current]="tier.isCurrentTier"
        >
          <div class="popular-badge" *ngIf="tier.isMostPopular">Most Popular</div>

          <h3 class="tier-name">{{ tier.name }}</h3>

          <div class="tier-price" *ngIf="tier.isFree">
            <span class="price-amount">Free</span>
          </div>
          <div class="tier-price" *ngIf="!tier.isFree">
            <ng-container *ngIf="priceForTier(tier) !== null; else priceUnavailable">
              <span class="price-amount">${{ priceForTier(tier) | number:'1.2-2' }}</span>
              <span class="price-period">/ {{ selectedPlan === 'monthly' ? 'mo' : 'yr' }}</span>
            </ng-container>
            <!-- Never render the monthly figure under a "/ yr" label just
                 because the annual scheme hasn't resolved (or isn't seeded). -->
            <ng-template #priceUnavailable>
              <span class="price-amount price-pending" *ngIf="!tier.schemeIdsLoaded">&hellip;</span>
              <span class="price-amount price-pending" *ngIf="tier.schemeIdsLoaded">Not available</span>
            </ng-template>
          </div>

          <p class="tier-description">{{ tier.description }}</p>

          <ul class="feature-list">
            <li *ngFor="let feature of tier.features">
              <span class="checkmark">&#10003;</span>{{ feature }}
            </li>
          </ul>

          <div class="tier-cta">
            <div class="current-plan-badge" *ngIf="tier.isCurrentTier">Current Plan</div>
            <div class="free-plan-badge" *ngIf="tier.isFree && !tier.isCurrentTier">Always Free</div>
            <button
              type="button"
              class="btn-select"
              [class.is-processing]="isProcessingTier(tier)"
              *ngIf="!tier.isFree && !tier.isCurrentTier"
              [disabled]="processing"
              (click)="selectTier(tier)"
            >
              <!-- Bind the label to THIS tier, not the shared `processing`
                   flag — otherwise every paid tier reads "Processing…" the
                   moment any one of them is clicked. The button still
                   disables via [disabled]="processing" above, which is what
                   prevents a second purchase. -->
              <span *ngIf="!isProcessingTier(tier)">Select {{ tier.name }}</span>
              <span *ngIf="isProcessingTier(tier)">Processing&hellip;</span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

    <div class="payment-secure" *ngIf="!loadingTiers && tiers.length > 0">
      <span>Secure checkout via</span>
      <strong>PayPal</strong>
    </div>

    <p class="payment-methods" *ngIf="!loadingTiers && tiers.length > 0">
      Pay with PayPal or as Guest (Debit/Credit).
    </p>

    <a href="javascript:void(0)" class="link-maybe-later" (click)="onMaybeLater()">
      Maybe Later
    </a>

    <p class="footer-text" *ngIf="lastMonthTopWinner">
      Monthly prizes are available to active Pro members only. Last month's top winner:
      <strong>${{ lastMonthTopWinner }}</strong>.
    </p>
  </div>
</div>
